import { z } from 'zod';

export const wizard_started = z.object({}).strict();

export const wizard_completed = z.object({
  input_line_count: z.number().int().nonnegative(),
  output_row_count: z.number().int().nonnegative(),
}).strict();
